/**
 * Normalize a file URL to work correctly across environments.
 *
 * Files stored locally have URLs like "/api/uploads/...".
 * Older records may contain absolute URLs with dead hostnames
 * (e.g. "https://old-preview.example.com/api/uploads/...").
 *
 * This function:
 * 1. Extracts the relative path from any absolute URL containing "/api/uploads/"
 * 2. Returns Cloudinary (or other external) URLs unchanged
 * 3. Returns relative paths as-is
 */
export function normalizeFileUrl(url) {
  if (!url) return '';

  // Already a relative path — use as-is
  if (url.startsWith('/api/uploads/')) return url;

  // Absolute URL pointing to our local upload route — extract relative path
  const marker = '/api/uploads/';
  const idx = url.indexOf(marker);
  if (idx !== -1) return url.slice(idx);

  // External URL (Cloudinary, etc.) — return unchanged
  return url;
}
